import { Entity, Field } from "typegraph";
import User from "panels/organizations/admin/entities/User";

@Entity({one: "message", many: "messages"})
export default class Message {

	@Field()
	public id: string;

	@Field()
	public type: string;
	
	@Field()
	public name: string;
	
	@Field()
	public summary: string;

    @Field()
    public startDate: string;
    
    @Field()
    public endDate: string;
	    
	@Field()
	public sortIndex: string;
	
	@Field({entity: User})
	public owner: User;
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/announcements/entities/Message.ts